const desktopNavMenuButtons = document.querySelectorAll("#primary-menu .menu-item-has-children #mega-menu-one__button");

const toggleDesktopMenuItem = (navButton) => {
  const buttonListElement = navButton.closest(".menu-item-has-children");
  const itemMegaMenu = buttonListElement.querySelector(".mega-menu-one");

  if (!buttonListElement || !itemMegaMenu) return;

  desktopNavMenuButtons.forEach((otherNavButton) => {
    const otherButtonListElement = otherNavButton.closest(".menu-item-has-children");
    const otherItemMegaMenu = otherButtonListElement.querySelector(".mega-menu-one");

    if (otherButtonListElement !== buttonListElement) {
      otherButtonListElement.classList.remove("open");
      otherItemMegaMenu.setAttribute("data-open", "false");
    }
  });

  buttonListElement.classList.toggle("open");
  const isOpen = itemMegaMenu.getAttribute("data-open") === "true";
  itemMegaMenu.setAttribute("data-open", isOpen ? "false" : "true");
};

desktopNavMenuButtons.forEach((navItemButton) => {
  navItemButton.addEventListener("click", (e) => {
    e.preventDefault();
    toggleDesktopMenuItem(navItemButton);
  });
});
